export default {
  ventures: "Venture | Ventures",
  browseVentures: "Browse startups within The Delta ecosystem",
  connectWith: "Connect with {name}",
  getInTouch: "Get in touch with {name} to learn more about their startup.",
  bookCall: "Book a call",
};
